module.exports = __webpack_public_path__ + "img/alibaba.c41123ed.svg";